<script>
import Modal from "@/components/_Shared/Modal";
import ErrorInput from "@/components/_Shared/ErrorInput";
import errorMixin from "@/mixins/errorMixin";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [errorMixin],

  data() {
    return {
      description: ""
    };
  },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  components: {
    Modal,
    ErrorInput
  },

  methods: {
    ...mapActions("orders", ["updateDescription"]),
    async submit() {
      await this.updateDescription({
        ...this.order,
        description: this.description
      });

      this.$emit("refresh");
    }
  },
  mounted() {
    this.description = this.order.description || "";
  }
};
</script>

<template>
  <modal
    title="Atualizar descrição"
    subtitle="Insira a nova descrição para o pedido"
    @close="$emit('close')"
  >
    <template slot="body">
      <v-textarea
        name="description"
        label="descrição"
        v-validate="'required|max:1024'"
        v-model="description"
        required
        :error-messages="errors.first('description')"
        :error="errors.has('description')"
        rows="5"
      ></v-textarea>
    </template>

    <template slot="footer">
      <button class="btn bg-purple-outline" @click="$emit('close')">
        cancelar
      </button>

      <button class="btn bg-purple" @click="submit">
        Atualizar descrição
      </button>
    </template>
  </modal>
</template>



// WEBPACK FOOTER //
// src/components/Orders/ShowOrder/UpdateDescription.vue